module.exports = __webpack_public_path__ + "img/_85C9093.4f2cd459.jpeg";